import { render, staticRenderFns } from "./Game2-1.vue?vue&type=template&id=227b86b6&scoped=true&"
import script from "./Game2-1.vue?vue&type=script&lang=js&"
export * from "./Game2-1.vue?vue&type=script&lang=js&"
import style0 from "./Game2-1.vue?vue&type=style&index=0&id=227b86b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227b86b6",
  null
  
)

export default component.exports